import React from 'react';
import AdminDashboard from './Admin';
import AgentDashboard from './Agent';

class Dashboard extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          isLoading: false,
          admin: false  
        }
    }

    componentDidMount = async () => {
      let user_data = localStorage.getItem("user_data")
      user_data = JSON.parse(user_data)
      let admin_bool = user_data["details"]["HKAdmin"]
      admin_bool ? this.setState({admin: true}) : this.setState({admin: false})
    }

    render(){
        return (
          <div className='flex h-screen'>
            <div className="absolute flex flex-col z-1 w-full h-screen top-0 left-0">
              {this.state.admin ? <AdminDashboard /> : <AgentDashboard />}
            </div>
          </div>
        )
    }
}

export default Dashboard